import { Modal, Stack } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import type { QuestionnaireResponse } from '@medplum/fhirtypes'
import * as questionnaires from '@seen/core/models/questionnaires/index'
import type { SDRAction } from '@seen/core/models/tasks/sdr/sdr-action'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { CustomQuestionnaireForm } from '#src/components/questionnaire-form/CustomQuestionnaireForm.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'

export function EditTaskDescription({
  sdrAction,
}: {
  sdrAction: SDRAction
}): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const patch = usePatchMutation<SDRAction>()
  const [opened, { toggle, close }] = useDisclosure(false)

  const handleChangeDescription = async (
    description: string
  ): Promise<void> => {
    patch.mutate({
      instance: sdrAction,
      mutateFn: (sdr) => {
        sdr.description = description
      },
    })
  }

  const onQuestionnaireSubmit = async (
    formData: QuestionnaireResponse
  ): Promise<void> => {
    const descriptionAnswer =
      questionnaires.extractTypedAnswersFromQuestionnaireResponse(
        formData,
        questionnaires.editTaskDescriptionQuestionnaire
      )

    if (descriptionAnswer.answers.description) {
      const description = descriptionAnswer.answers.description
      await handleChangeDescription(description)
      close()
    }
  }

  return (
    <div>
      <Button className="w-full" onClick={toggle} disabled={isReadOnly}>
        Change Description
      </Button>
      <Modal opened={opened} onClose={close}>
        <Stack>
          <CustomQuestionnaireForm
            questionnaire={questionnaires.editTaskDescriptionQuestionnaire}
            onSubmit={onQuestionnaireSubmit}
          />
        </Stack>
      </Modal>
    </div>
  )
}
